<template>
    <div class="language_box right">
        <p class="language_btn" @click="isShow = !isShow">
            <img src="/img/language_icon.svg" alt="" />
        </p>
        <transition name="fade">
            <div class="language_show" v-show="isShow">
                <ul>
                    <li v-for="(langCode, index) in languages" :key="index">
                        <a
                            href="javascript:void(0)"
                            :class="{ active: langCode == currentLanguage }"
                            @click="changeLanguage(langCode)"
                            >{{ languageCodeText[langCode] }}</a
                        >
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        languages: {
            type: Array,
            default: function () {
                return [];
            },
        },
        defaultLanguage: {
            type: String,
            default: "en",
        },
    },
    data() {
        return {
            isShow: false,
            languageCodeText: {
                browser: "Your browser language",
                en: "English",
                ja: "Japanese",
                "zh-Hans": "Chinese Simplified",
                "zh-Hant": "Chinese Traditional",
                ko: "Korean",
                fr: "French",
                de: "German",
                it: "Italian",
                pt: "Portuguese",
                ru: "Russian",
                es: "Spanish",
                ar: "Arabic"
            },
            currentLanguage: "",
        };
    },
    methods: {
        changeLanguage(payload) {
            this.currentLanguage = payload;
            this.$emit("changedLanguage", this.currentLanguage);
        },
    },
    created() {
        this.currentLanguage = this.defaultLanguage;
    },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: transform 0.5s;
}
.fade-enter,
.fade-leave-to {
    transform: translateY(-50%) scaleY(0) !important;
}
</style>